var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('core-app-bar-nat',[_c('core-sub-app-bar')],1),_c('core-drawer'),_c('core-view'),_c('core-footer'),_c('core-float-buttons'),_c('mensaje-sitio'),_c('gtm-injector',{attrs:{"id":'GTM-WWGMCC2W'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }